import React, { ReactElement } from 'react';

import { Typography } from '@mui/material';

interface Props {
  label: string | undefined;
  value: string | number | undefined | null | ReactElement | JSX.Element;
}
const LineItem: React.FC<Props> = ({ label, value }) => {
  return (
    <Typography component={'div'} key={label} variant='body2'>
      {label}: {value}
    </Typography>
  );
};

export default LineItem;
